module.exports = __webpack_public_path__ + "static/media/tekno.95e52d82.png";